export const getActiveItemIndex = (key, activeFilters) => activeFilters?.findIndex(({ categoryKey }) => categoryKey === key);
//# sourceMappingURL=getActiveItemIndex.js.map